export default __webpack_public_path__ + "static/media/number7.183d2b64.svg";